.star-ratings {
  pointer-events: none;
}
.star-ratings.mode__edit {
  pointer-events: all;
}
.star-ratings span {
  vertical-align: middle;
  padding: 0 1px;
}
.star-ratings span svg {
  width: 21px;
  height: 21px;
  cursor: pointer;
}

.star-filled svg path {
  fill: #fdcc0d;
}

.star-empty svg path {
  fill: none;
  stroke-width: 80px;
  stroke: #fdcc0d;
}

.star-empty.start-handing svg path {
  fill: #fdcc0d!important;
}

